
import {checkThirdPartyCookies} from '@/data/cookies';
import {GameResponse} from '@/data/types';
// @ts-ignore
import {ReCaptchaV2} from 'grecaptcha';
import {defineComponent, onBeforeUnmount, onMounted, ref} from 'vue';
import {useRouter} from 'vue-router';
import {getRecaptcha} from '../data/recaptcha';

export default defineComponent({
	setup() {
		const router = useRouter();

		const complete = ref(false);
		const loaded = ref(false);
		const error = ref<string>();
		const hubUrl = ref<string>();

		const formLoaded = ref(false);
		const formError = ref<string>();
		const thirdPartyCookies = ref<boolean | null>();

		const username = ref('');
		const activeUsername = ref<string | null>(null);
		const activeGameTitle = ref<string | null>(null);

		const recaptchaContainer = ref<HTMLDivElement>();
		let captcha: ReCaptchaV2 | undefined;
		let captchaId: string;

		onMounted(async () => {
			document.title = 'Register | ' + process.env.VUE_APP_TITLE;

			const response = await fetch(`${process.env.VUE_APP_API_PATH}/games/shroom22`);

			if (!response.ok) {
				error.value = `Something went wrong loading game data. Please try again later. (${response.status} ${response.statusText})`;
				return;
			}

			const data: GameResponse = await response.json();
			if (data.user && !data.noParticipant) return router.replace({name: 'home'});

			hubUrl.value = data.hubUrl;
			loaded.value = true;

			thirdPartyCookies.value = await checkThirdPartyCookies();

			if (data.user) {
				activeGameTitle.value = data.user.activeGameTitle;
				activeUsername.value = data.user.name;
			} else if (thirdPartyCookies.value) {
				captcha = await getRecaptcha();
				captchaId = captcha.render(recaptchaContainer.value!, {
					sitekey: data.recaptchaKey,
				});
			}

			formLoaded.value = true;
		});

		onBeforeUnmount(() => {
			captcha?.reset(captchaId);
		});

		const register = async () => {
			let recaptchaResponse: string | undefined;

			if (!activeGameTitle.value) {
				recaptchaResponse = captcha.getResponse(captchaId);
				if (!recaptchaResponse) {
					formError.value = 'Confirm to not be a robot.';
					return;
				}
			}

			formLoaded.value = false;
			const response = await fetch(`${process.env.VUE_APP_API_PATH}/register`, {
				method: 'post',
				headers: {'content-type': 'application/json'},
				body: JSON.stringify({
					gameId: 'shroom22',
					username: username.value.trim() || undefined,
					recaptchaResponse,
				}),
			});

			if (!response.ok) {
				// todo: error from response
				formError.value = `Something went wrong registering. Please try again later. (${response.status} ${response.statusText})`;
				formLoaded.value = true;
				return;
			}

			complete.value = true;
		};

		return {
			title: process.env.VUE_APP_TITLE,
			loaded, error, hubUrl,
			formLoaded, formError, thirdPartyCookies,
			activeGameTitle, activeUsername,
			username,
			register, recaptchaContainer,
			complete,
		};

	},
});
